export const baseURL = 'https://ms-checkout-staging.provi.com.br';
